import styled from '@emotion/styled';
import PropTypes from 'react-proptypes';
import { Info } from 'shared/components';

const DisplayContainer = styled.p`
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    
    > span {
        font-family: ${({theme}) => theme.fontFamily};
        font-weight: 600;
        letter-spacing: -0.5px;
        line-height: 18px;
    }
    
    &:not(:last-of-type) {
        margin-bottom: 16px;
    }
    
    > span:first-of-type {
        color: ${({theme}) => theme.primaryFontColor};
    }
    
    > span:last-of-type {
        color: ${({theme}) => theme.primaryColor};
    }

    @media ${({ theme }) => theme.mobile} {
        font-size: 16px;    
    }
`;

const Display = ({label, infoText, value, ...props}) => {
  let displayValue = value;
  if (typeof value === "boolean") displayValue = value ? 'Ja' : 'Nee';
  return (
    <DisplayContainer {...props}>
      <span>
        {label}
        {infoText && (
          <Info
            title={label}>
            {infoText}
          </Info>
        )}
      </span>
      <span>{displayValue}</span>
    </DisplayContainer>
  );
}

Display.propTypes = {
  label: PropTypes.string,
  infoText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.element,
  ])
}

Display.defaultProps = {
  value: '',
  infoText: '',
}

export default Display;
